module.exports = __webpack_public_path__ + "media/images/icons/close-0d167b94acb0e5d52bf51b7d61242705.svg";